export default "__VITE_ASSET__7f9f20fa__"